module.exports = __webpack_public_path__ + "static/itc-avantgardestd-demi-c44d8de89056156558b17347e7a02b27.woff";